import { LEGAL_COMPLIANCE_COPY } from "@/features/legal/config/legal.config";

const SKELETON_BLOCK_CLASS = "animate-pulse rounded-md bg-gray-200 motion-reduce:animate-none dark:bg-gray-700";

export const LegalComplianceSkeleton = () => (
  <div className="space-y-6" aria-busy="true">
    <span className="sr-only">{LEGAL_COMPLIANCE_COPY.LOADING}</span>
    <div className="space-y-2">
      <div className={`h-7 w-2/3 ${SKELETON_BLOCK_CLASS}`} />
      <div className={`h-4 w-1/3 ${SKELETON_BLOCK_CLASS}`} />
    </div>
    <div className="space-y-3">
      <div className={`h-4 w-full ${SKELETON_BLOCK_CLASS}`} />
      <div className={`h-4 w-full ${SKELETON_BLOCK_CLASS}`} />
      <div className={`h-4 w-5/6 ${SKELETON_BLOCK_CLASS}`} />
    </div>
  </div>
);
